import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full max-w-[1113px] min-w-[328px] mb-20 custom-quill" }
const _hoisted_2 = { class: "text-h-primary-600 font-extrabold !text-[14px]" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "w-[1113px] mx-auto" }
const _hoisted_6 = { class: "sm:w-sm md:w-md lg:w-[1008px] xl:w-[1113px]" }
const _hoisted_7 = { class: "text-xl text-h-neutral-900 leading-7 ml-[2px] mb-[3.8px]" }
const _hoisted_8 = { class: "ql-formats" }
const _hoisted_9 = { class: "ql-bold" }
const _hoisted_10 = { class: "ql-italic" }
const _hoisted_11 = { class: "ql-underline" }
const _hoisted_12 = { class: "ql-formats" }
const _hoisted_13 = {
  class: "ql-list",
  value: "ordered"
}
const _hoisted_14 = {
  class: "ql-list",
  value: "bullet"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, null, -1)
const _hoisted_16 = { class: "ql-formats" }
const _hoisted_17 = {
  class: "ql-link",
  value: "link"
}
const _hoisted_18 = { class: "ql-code-block" }
const _hoisted_19 = { class: "w-[93vw] sm:w-[624px] md:w-[752px] lg:w-[992px] xl:w-[1113px] custom-comment-input" }
const _hoisted_20 = { class: "max-w-[1113px] mx-auto" }
const _hoisted_21 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AddFileInput = _resolveComponent("AddFileInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createNewComment && _ctx.createNewComment(...args)), ["prevent"]))
    }, [
      (_ctx.replyOfComment?.id)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["relative flex flex-col w-full gap-2 p-3 mb-4 border-l-8 rounded", `${
          _ctx.replyOfComment?.comment
            ? 'bg-h-primary-50 border border-h-primary-100'
            : 'bg-h-neutral-100 border border-h-neutral-200 text-h-neutral-700 font-normal	'
        }`])
          }, [
            _createElementVNode("button", {
              class: "rounded-full flex justify-center items-center absolute top-3 right-3 w-[18px] h-[18px]",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeReplyComment()))
            }, [
              _createVNode(_component_v_icon, {
                name: "md-close",
                width: "16px",
                height: "16px",
                class: "text-h-neutral-700"
              })
            ]),
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.replyOfComment?.authorUser?.name
              ? _ctx.replyOfComment?.authorUser?.name + ":"
              : _ctx.$t("forum.comment.authorDeleted") + ":"), 1),
            (_ctx.replyOfComment?.comment)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  innerHTML: _ctx.replyOfComment?.comment,
                  class: "ql-editor text-sm text-h-neutral-700 !whitespace-pre-wrap !truncate !line-clamp-3 md:!line-clamp-2 !inline-block !text-wrap"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Comentário excluído.",
                en: "Comment deleted.",
              })), 1)
                ]))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("fieldset", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Adicionar comentário",
                en: "Add comment",
              })), 1),
          _createVNode(_component_Editor, {
            modelValue: _ctx.form.comment,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.comment) = $event)),
            class: _normalizeClass(["mb-3 w-[93vw] sm:w-[624px] md:w-[752px] lg:w-[992px] xl:w-[1113px] custom-comment-input", [
              { 'border !border-red-600 rounded-md': _ctx.v$.form.comment.$error },
            ]]),
            editorStyle: "height: 160px; max-width: inherit;"
          }, {
            toolbar: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("button", _hoisted_9, null, 512), [
                  [
                    _directive_tooltip,
                    'Bold',
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_10, null, 512), [
                  [
                    _directive_tooltip,
                    'Italic',
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_11, null, 512), [
                  [
                    _directive_tooltip,
                    'Underline',
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("button", _hoisted_13, null, 512), [
                  [
                    _directive_tooltip,
                    'Ordered',
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_14, null, 512), [
                  [
                    _directive_tooltip,
                    'Bullet',
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("button", _hoisted_17, null, 512), [
                  [
                    _directive_tooltip,
                    'Link',
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_18, null, 512), [
                  [
                    _directive_tooltip,
                    'CodeBlock',
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "class"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.comment.$errors,
              actualLength: _ctx.form.comment?.length,
              maxLength: 700
            }, null, 8, ["errors", "actualLength"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        (!_ctx.isImageBeingEmbedded)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _ctx.showEmbedImageComponent,
              class: "!p-0 btn-simple !mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  name: "hi-upload",
                  class: "mr-2"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Anexar imagem",
              en: "Attach image",
            })), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_AddFileInput, {
              key: 1,
              onOnSetImage: _ctx.setCommentImage,
              onOnResetImage: _ctx.resetCommentImage,
              imageSelected: _ctx.image
            }, null, 8, ["onOnSetImage", "onOnResetImage", "imageSelected"])),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Button, {
            type: "submit",
            class: "btn-primary transition-all bg-h-primary-500 my-2 px-2 rounded flex items-center justify-center text-white font-bold w-[79px] h-8 box-border",
            label: _ctx.$t('labels.generic', { pt: 'Publicar', en: 'Publish' })
          }, null, 8, ["label"])
        ])
      ])
    ], 32)
  ]))
}